import React from "react";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import BranchLink from "web/react/components/branch-link/branch-link";
import { RawBranchLink } from "web/script/utils/branch-io";
import styles from "./homepage-business-value.css";

interface BusinessValueType {
    title: string;
    description: string;
    link_title: string;
    img_url: string;
    url: string;
    is_branch_link: boolean;
}

interface BusinessValueSection {
    section: BusinessValueType;
}

export function BusinessValueSection({ section }: BusinessValueSection): JSX.Element {
    return (
        <div className={styles.businessValueSection}>
            <LazyLoadImage src={section.img_url} alt={section.title} className={styles.image} />
            <div className={styles.textBlock}>
                <h3 className={styles.title}>{section.title}</h3>
                <p className={styles.message}>{section.description}</p>
                {section.is_branch_link ? (
                    <BranchLink
                        title={""}
                        className={styles.link}
                        branchLink={RawBranchLink.Homepage}
                        eventLabel={"homepage_download_badge"}
                    >
                        <span>
                            {section.link_title}
                            <SVGIcon className={styles.chevron} name="chevron" />
                        </span>
                    </BranchLink>
                ) : (
                    <a className={styles.link} href={section.url}>
                        {section.link_title}
                        <SVGIcon className={styles.chevron} name="chevron" />
                    </a>
                )}
            </div>
        </div>
    );
}

interface HomepageBusinessValueProps {
    sections: BusinessValueType[];
}

function HomepageBusinessValue({ sections }: HomepageBusinessValueProps): JSX.Element {
    return (
        <div className={styles.businessValue}>
            {sections.map((section) => (
                <BusinessValueSection key={section.url} section={section} />
            ))}
        </div>
    );
}

export default HomepageBusinessValue;
